module.exports = __webpack_public_path__ + "static/media/tishiyin.7c2a4cf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tishiyin.mp3
// module id = WQok
// module chunks = 5